// Generated from SVG to Code Figma Plugin
'use client';
import React from 'react';
import { chakra } from '@chakra-ui/react';

type Props = {
  width?: number;
  fill?: string;
  onClick?: () => void;
};

export const AlertClose = ({ fill = 'none', width = 14, onClick }: Props) => (
  <chakra.svg
    width="10px"
    height="10px"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      d="M4.9985 4.05767L8.29836 0.757812L9.24117 1.70062L5.9413 5.00047L9.24117 8.30027L8.29836 9.24306L4.9985 5.94327L1.69867 9.24306L0.755859 8.30027L4.0557 5.00047L0.755859 1.70062L1.69867 0.757812L4.9985 4.05767Z"
      fill="white"
    />
  </chakra.svg>
);
